import { Box } from '@material-ui/core'
import React from 'react'

import { isConsole } from '../../config/config'
import { Handler } from '../../helpers/typeHelper'
import { useRepaymentPolicy } from '../../hooks/query/useRepaymentPolicy'
import { useRepaymentPolicyDocuments } from '../../hooks/query/useRepaymentPolicyDocuments'
import { RepaymentPolicyStatus } from '../../models/repayments'
import { ConsoleTeam } from '../../models/team'
import { VendorUser } from '../../models/user'
import { Button } from '../Button/Button'
import { PageTitle } from '../PageTitle/PageTitle'
import { InlineSpinner } from '../Spinner'
import { getPolicyHeader } from './Policy.helper'
import { PolicyActivity } from './PolicyDetail/PolicyActivity'
import { PolicyDetailBilling } from './PolicyDetail/PolicyDetailBilling'
import { PolicyDetailCard } from './PolicyDetail/PolicyDetailCard'
import { PolicyDetailHeader } from './PolicyDetail/PolicyDetailHeader'
import { PolicyDetailHistory } from './PolicyDetail/PolicyDetailHistory'
import { PolicyDetailsDropdown } from './PolicyDetail/PolicyDetailsDropdown'
import { PolicyDocuments } from './PolicyDetail/PolicyDocuments'

interface PolicyBaseDetailsProps {
  teamUrl?: string
  policyId: string
  handleTeamRedirect?: Handler
  handlePolicyRedirect: Handler
  handleRefinanceRedirect: Handler
}

interface PolicyTeamDetailsProps {
  team: ConsoleTeam
  vendorUser?: never
}

interface PolicyVendorUserDetailsProps {
  vendorUser: VendorUser
  team?: never
}

type PolicyDetailsProps = PolicyBaseDetailsProps & (PolicyTeamDetailsProps | PolicyVendorUserDetailsProps)

export function PolicyDetails({
  team,
  vendorUser,
  policyId,
  teamUrl,
  handleTeamRedirect,
  handlePolicyRedirect,
  handleRefinanceRedirect,
}: PolicyDetailsProps) {
  const { policy, refetch: refetchPolicy } = useRepaymentPolicy({
    teamId: team?.id,
    vendorId: vendorUser?.vendor.id,
    policyId,
  })
  const { policyDocuments, refetch: refetchDocuments } = useRepaymentPolicyDocuments(policyId)

  if (!policy) return <InlineSpinner />

  return (
    <>
      <PageTitle title={getPolicyHeader(policy)} />
      <PolicyDetailHeader policy={policy} teamUrl={teamUrl}>
        <>
          <PolicyDetailsDropdown
            policy={policy}
            refetchPolicy={refetchPolicy}
            handlePolicyRedirect={handlePolicyRedirect}
            handleRefinanceRedirect={handleRefinanceRedirect}
            isVendor={Boolean(vendorUser)}
          />
          {policy.repayment_details.policy_status === RepaymentPolicyStatus.DRAFT && isConsole() && (
            <>
              <Box mt={1} />
              <Button variant="secondary" size="medium" onClick={handleTeamRedirect}>
                Edit details
              </Button>
            </>
          )}
        </>
      </PolicyDetailHeader>

      <Box mt={4} />
      <PolicyDetailCard>
        <PolicyDetailBilling policy={policy} />
      </PolicyDetailCard>

      <Box mt={2} />
      <PolicyDetailCard>
        <PolicyDocuments
          policyDocuments={policyDocuments}
          policy={policy}
          refetchDocuments={refetchDocuments}
        />
      </PolicyDetailCard>

      <Box mt={2} />
      <PolicyDetailCard styles="padding-bottom: 10px;">
        <PolicyActivity policy={policy} refetchPolicy={refetchPolicy} />
      </PolicyDetailCard>

      <Box mt={2} />
      <PolicyDetailCard styles="padding-bottom: 10px;">
        <PolicyDetailHistory policy={policy} />
      </PolicyDetailCard>
    </>
  )
}
